import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkHealth } from '../services/api';

const AuthHandler = ({ children }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('token');
      const email = params.get('email');
      const given_name = params.get('given_name');
      const surname = params.get('surname');

      // If we have auth params from redirect, store them
      if (token) {
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem('userEmail', email);
        sessionStorage.setItem('userGivenName', given_name);
        sessionStorage.setItem('userSurname', surname);
        
        // Clean up URL params
        navigate('/', { replace: true });
        
        // Validate the new token with health check
        const healthResult = await checkHealth();
        if (healthResult.isAuthorized) {
          setIsAuthenticated(true);
          setIsLoading(false);
          return;
        }
      }

      // Check if we already have a token
      const existingToken = sessionStorage.getItem('authToken');
      if (existingToken) {
        // Validate existing token with health check
        const healthResult = await checkHealth();
        
        if (healthResult.isAuthorized) {
          setIsAuthenticated(true);
          setIsLoading(false);
          return;
        } else {
          // Token is invalid, clear storage
          sessionStorage.removeItem('authToken');
          sessionStorage.removeItem('userEmail');
          sessionStorage.removeItem('userGivenName');
          sessionStorage.removeItem('userSurname');
        }
      }

      // No authentication found or token invalid - redirect immediately without showing content
      setIsAuthenticated(false);
      setIsLoading(false);
      
      // Use setTimeout to ensure state is set before redirect
      setTimeout(() => {
        window.location.href = 'https://login.microsoftonline.com/ac1f7d2b-c741-43f6-9893-d39b22c46953/saml2?SAMLRequest=jZHLasMwEEV%2fxWjvt9O6wjY4LwikUNLHoruJPGncyJKqkdLH19dNyKpQuh3mHuaeqQgGaXjr3V5t8M0jueBjkIpq5q3iGqgnrmBA4k7w%2b%2fZ2zbMo4QM66MABC1bzmi3LYl6WZdvm06KYpdOyKPLrSVssyixN5jcLFjyhpV6rmo3hMUPkcaXIgXLjKMkmYVKGafaQZjwpeZ5GeZI9%2f%2bzdAVF%2fxJrtQBKyoCVC60bSTCvyA9p7tMde4ONmXbO9c4Z4HG%2bvlDAv9igBdz0WJtfdp%2bpF3mHy9XowIpIwbDsIvZWRpxCBXJhGWkXwTjGYPobRRixAyi2IAzv74CdRf1sxVjsttGTBUluBJ6mX05vq1Nr%2bxy5cWrLG7Edk6I3U0IUjv6viM6ep4t%2bva74B';
      }, 0);
    };

    checkAuthentication();
  }, [navigate]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-eab-blue mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, show nothing (will redirect)
  if (!isAuthenticated) {
    return null;
  }

  // Only render children if authenticated
  return children;
};

export default AuthHandler;
